<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? $t('createunitconversion.Editunitconversion')
        : $t('createunitconversion.ConvertUnits')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="12" lg="6" md="6" cols="12">
          <div class="field">
            <CustomDropDown
              v-model="insert_data.FromUnit"
              :label="$t('createunitconversion.FromUnit')"
              :items="options.fromunits"
              :rules="{ required: true }"
              name="From Unit"
              id="From Unit"
              :required-icon="true"
              @update:modelValue="selectfromunit(insert_data.FromUnit)"
            />
          </div>
        </b-col>
        <b-col sm="12" lg="6" md="6" cols="12" class="addcircle_field">
          <div class="field">
            <CustomDropDown
              v-model="insert_data.ToUnit"
              :label="$t('createunitconversion.ToUnit')"
              id="To Unit"
              name="To Unit"
              :rules="{ required: true }"
              :required-icon="true"
              :items="options.tounits"
            />
          </div>
          <span
            class="add_circle"
            @click="FunctionRights(EntityIds.Unit, 'Unit')"
            ><i class="pi pi-plus"></i
          ></span>
          <!-- <span class="float-end blue-txt" @click="FunctionRights(EntityIds.Unit, 'Unit')">+ Add Unit</span> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="insert_data.ConversionFactor"
              type="number"
              :label="$t('createunitconversion.ConversionFactor')"
              clearable
              id="ConversionFactor"
              name="ConversionFactor"
              :rules="{ required: true, numeric: true }"
              :required-icon="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <CustomTextArea
              v-model="insert_data.Description"
              :requiredIcon="false"
              placeholder=" "
              name="Description"
              id="Description"
              :label="$t('createunitconversion.Description')"
              :rules="{ required: false }"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist
    selectedcontent="Conversion Unit Already Exist"
    :visible="alreadyexistpop"
    @ok="alreadyclosetrigger()"
  />
  <Unitcreastion
    v-model:trigger="DialogShow.Unit"
    v-if="DialogShow.Unit"
    @load="LoadUnits(), (DialogShow.Unit = false)"
    @close="DialogShow.Unit = false"
    :OperationID="ObjOperationId"
    ,
    :EntityId="EntityIds.Unit"
  />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
import service from "../../../../Service/UnitConversionService";
import unitservice from "../../../../Service/UnitMasService";
import { useRoute } from "vue-router";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomTextArea from "../../../../../../components/FormComponents/TextArea.vue";
import MastersService from "../../../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import Unitcreastion from "../../../../../../modules/Inventory/pages/Masters/Items/UnitMaster/UnitCreation.vue";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    CustomDropDown,
    CustomTextArea,
    Unitcreastion,
  },
  setup(props, { emit }) {
    debugger;
    const toast = useToast();
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();

    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);
    const alreadyexistpop = ref(false);

    let options = ref({
      fromunits: [],
      tounits: [],
    });

    const insert_data = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      OrganizationId: 0,
      Id: 0,
      FromUnit: ref(),
      ToUnit: ref(),
      ConversionFactor: ref(),
      Description: "",
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      Unit: false,
    });
    let EntityIds = ref({
      Unit: 103,
    });
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      LoadUnits();
    });

    //Load Units
    const LoadUnits = async () => {
      debugger;
      const response = await unitservice.getdata();
      console.log(response["result"]);
      options.value.fromunits = response["result"]
        .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId)
        .map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      options.value.tounits = options.value.fromunits;
    };

    let selectedfromunitvalue: any = ref([]);

    const selectfromunit = (data) => {
      debugger;
      insert_data.value.ToUnit = null;
      options.value.tounits = options.value.fromunits;
      selectedfromunitvalue.value = [];
      selectedfromunitvalue.value.push(data);
      options.value.tounits = options.value.tounits.filter(
        (i: any) => !selectedfromunitvalue.value.includes(i.Id)
      );
    };

    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (event.altKey && event.key == "n") {
        showDialog.value = true;
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      }
    }

    //Clear Input Fields
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);
      insert_data.value.Id = 0;
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    }

    // Add New PopUp
    function IsCreate() {
      debugger;
      showDialog.value = true;
    }

    //Row Edit
    async function IsEdit() {
      debugger;
      try {
        label.value = t("btn.update");
        const EditId = model.value.Id;
        const response = await service.Edit(EditId);
        const data = response["result"];
        console.log(response["result"]);
        insert_data.value.Id = data.Id;
        insert_data.value.FromUnit = data.Fromunit;
        await LoadUnits();
        await selectfromunit(data.Fromunit);
        insert_data.value.ToUnit = data.Tounit;
        insert_data.value.Description = data.description;
        insert_data.value.ConversionFactor = data.ConversionFactor;
        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    }

    //Save
    const IsSubmit = async () => {
      debugger;
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        let msg = "";
        insert_data.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        insert_data.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        insert_data.value.BranchId = 0;
        insert_data.value.HospitalId = HospitalId;
        insert_data.value.ModifiedBy = UserId;
        insert_data.value.CreatedBy = UserId;
        insert_data.value.ConversionFactor = Number(
          insert_data.value.ConversionFactor
        );
        let objinsert = Object.assign(insert_data.value);
        console.log(objinsert);
        if (insert_data.value.Id != 0) {
          const data_response = await service.Update(insert_data.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          const data_response = await service.insert(insert_data.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        alert(error);
      }
    };

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }
    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    return {
      LoadUnits,
      ObjOperationId,
      EntityIds,
      DialogShow,
      FunctionRights,
      showModal: ref(false),
      insert_data,
      IsSubmit,
      IsEdit,
      IsClear,
      showDialog,
      IsCreate,
      successpop,
      updatepop,
      closetrigger,
      label,
      Saveloading,
      options,
      selectfromunit,
      alreadyexistpop,
      alreadyclosetrigger,
      model,
    };
  },
});
</script>
